import SinglePaygo from '../../../features/paygo/components/SinglePayGo'

export default function SinglePaygoPage() {
  return (
    <div style={{width: '100%', display: 'flex', alignItems:'center', flexDirection:'column'}}>
      <SinglePaygo.Code />
      <div style={{height: 30}}/>
      <SinglePaygo.GenericInfo />
    </div>
  )
}
